import { onChangeMoveToMailboxType, onViewAllMenuClicked } from '../actions/internalActions';
import { lazyGetArchiveFolders, lazyGetSharedFoldersForSpecificRoot } from 'owa-folders';
import { orchestrator } from 'satcheljs';

const VIEW_ALL_MOVE_TO_MENU = 'VIEW_ALL_MOVE_TO_MENU';

// gets called when user clicks on view all menu item for any mailbox
orchestrator(onViewAllMenuClicked, async actionMessage => {
    onChangeMoveToMailboxType(actionMessage.moveToMailboxType);
    switch (actionMessage.moveToMailboxType) {
        case 'ArchiveMailbox':
            (await lazyGetArchiveFolders.import())(
                VIEW_ALL_MOVE_TO_MENU /* Archive mailbox folders loading source */
            );
            break;
        case 'SharedMailbox':
            (await lazyGetSharedFoldersForSpecificRoot.import())(
                // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
                // -> Error TS2345 (21,17): Argument of type 'string | undefined' is not assignable to parameter of type 'string'.
                // @ts-expect-error
                actionMessage.rootFolderId /* Specific shared folder primary SMTP address */,
                'moveToControl' /* actionSource */
            );
            break;
        default:
            return;
    }
});
